if (!customElements.get("c-header-wishlist")) {
  customElements.define(
    "c-header-wishlist",
    class HeaderWishlist extends HTMLElement {
      connectedCallback() {
        this.counter = this.querySelector(".js-header__wishlist-count");
        this.button = this.querySelector(".js-header__wishlist-button");

        if (!this.counter || !this.button) return;

        this.init();
      }

      disconnectedCallback() {
        this.wishlistReadyUnsubscriber?.();
        this.wishlistUpdatedUnsubscriber?.();
      }

      async init() {
        try {
          const store = window.WishlistStore;

          if (!store) {
            console.error("[HeaderWishlist] WishlistStore is not available");
            return;
          }

          store.setConsent?.(true);

          const state = await store.init?.();

          this.updateHeaderWishlistCount(state || store.getState?.() || {});
          this.show();

          this.subscribeToWishlistEvents();
        } catch (error) {
          console.error("[HeaderWishlist] init failed:", error);
        }
      }

      subscribeToWishlistEvents() {
        this.wishlistReadyUnsubscriber = window.PubSub?.subscribe?.(
          "wishlist:ready",
          ({ state }) => {
            this.updateHeaderWishlistCount(state);
            this.show();
          }
        );

        this.wishlistUpdatedUnsubscriber = window.PubSub?.subscribe?.(
          "wishlist:updated",
          ({ state }) => {
            this.updateHeaderWishlistCount(state);
            this.show();
          }
        );
      }

      updateHeaderWishlistCount(state = {}) {
        const count = Array.isArray(state.items)
          ? state.items.length
          : Number(state.count || 0);

        this.counter.textContent = String(count);
        this.counter.setAttribute("data-count", String(count));

        this.counter.classList.remove("is-hidden");
        this.counter.classList.toggle("is-active", count > 0);

        this.button.classList.toggle("is-wishlist-empty", count === 0);
        this.button.classList.toggle("is-wishlist-filled", count > 0);

        this.classList.toggle("is-wishlist-empty", count === 0);
        this.classList.toggle("is-wishlist-filled", count > 0);
      }

      show() {
        this.classList.remove("is-wishlist-loading");
        this.classList.add("is-wishlist-loaded");

        document.body.classList.add("wishlist-ready");
      }
    }
  );
}